import {
  ETextParamType_SetPlayerPriority,
  ETextParamType_SetWebCamTrackingPoseData,
  ETextParamType_SetWebCamTrackingHandData
} from './const';
import {hel_setText} from './moduleCaller';

/**
 * プレイヤーの表示優先度を変更する
 * @param PlayerID
 * @param Priority
 */
export const hel_player_SetPriority = (PlayerID: string, Priority: number) => {
  hel_setText(ETextParamType_SetPlayerPriority, PlayerID + ',' + Priority.toString());
};

/**
 * @param text_context
 */
export const hel_remove_emoji = (text_context: HTMLInputElement) => {
  const regex_conditions =
    /\p{Emoji_Modifier_Base}\p{Emoji_Modifier}?|\p{Emoji_Presentation}|\p{Emoji}\uFE0F/gu;
  text_context.value = text_context.value.replaceAll(regex_conditions, '*');
};

export const hel_webcamtracking_setposedata = (text: string) => {
  hel_setText(ETextParamType_SetWebCamTrackingPoseData, text);
};

export const hel_webcamtracking_sethanddata = (text: string) => {
  hel_setText(ETextParamType_SetWebCamTrackingHandData, text);
};
